import z from 'zod'

import { filtersSchema } from '@/shared/components/filter/validation'

export const bulkFinalFieldsRequestSchema = z.array(
	z.object({
		filters: filtersSchema,
		final_fields: z.record(z.string(), z.any()),
	})
)
